import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {FeatureLaunchpadRoutingModule} from "../feature-launchpad.routing.module";

// PrimeNG
import {ButtonModule} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {TextareaModule} from "primeng/textarea";
import {SelectModule} from "primeng/select";
import {InputNumberModule} from "primeng/inputnumber";
import {TableModule} from "primeng/table";
import {TabsModule} from "primeng/tabs";
import {TagModule} from "primeng/tag";
import {TooltipModule} from "primeng/tooltip";

// TinyMCE
import {EditorModule} from "@tinymce/tinymce-angular";

// Components
import {LaunchpadBaseComponent} from "./component/launchpad-base/launchpad-base.component";
import {AiChatPanelComponent} from "./component/ai-chat-panel/ai-chat-panel.component";
import {HelpSearchComponent} from "./component/help-search/help-search.component";
import {HelpArticleViewerComponent} from "./component/help-article-viewer/help-article-viewer.component";
import {ArticleEditorComponent} from "./component/article-editor/article-editor.component";
import {GlossaryPanelComponent} from "./component/glossary-panel/glossary-panel.component";
import {GuidedTourComponent} from "./component/guided-tour/guided-tour.component";

// Pages
import {LpLaunchpadPage} from "./page/launchpad-page/launchpad.page";
import {LpArticleDetailPage} from "./page/article-detail-page/article-detail.page";
import {LpHelpAdminPage} from "./page/help-admin-page/help-admin.page";

// Services (providedIn: root, so no providers needed)
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";

@NgModule({
    declarations: [
        // Components
        LaunchpadBaseComponent,
        AiChatPanelComponent,
        HelpSearchComponent,
        HelpArticleViewerComponent,
        ArticleEditorComponent,
        GlossaryPanelComponent,
        GuidedTourComponent,
        // Pages
        LpLaunchpadPage,
        LpArticleDetailPage,
        LpHelpAdminPage,
    ],
    exports: [
        // Components available to other modules
        LaunchpadBaseComponent,
        AiChatPanelComponent,
        HelpSearchComponent,
        HelpArticleViewerComponent,
        ArticleEditorComponent,
        GlossaryPanelComponent,
        GuidedTourComponent,
        // Pages
        LpLaunchpadPage,
        LpArticleDetailPage,
        LpHelpAdminPage,
    ],
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        UiModule,
        FeatureLaunchpadRoutingModule,
        // PrimeNG
        ButtonModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        InputNumberModule,
        TableModule,
        TabsModule,
        TagModule,
        TooltipModule,
        // TinyMCE
        EditorModule,
    ]
})
export class LaunchpadModule implements DynamicModule {

    alias = 'lp';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }
}
